export default {
  getBreadcrumbCurrentView(state) {
    return state.breadcrumbCurrentView
  },
  getBreadcrumbCurrentSubView(state) {
    return state.breadcrumbCurrentSubView
  },
}
